/**
 * Field lists for narrowly-memoized sub-forms so large sections skip re-render
 * when unrelated `formData` keys change (major perf on ImportBookingForm).
 */

export const ROUTING_FORM_FIELD_KEYS = [
    "CoLoader",
    "CarrierName",
    "CarrierID",
    "CarrierSCAC",
    "VesselId",
    "VesselName",
    "Voyage",
    "ConMotherVessel",
    "ConMotherVoyage",
    "RI_Flag",
    "RI_Lloyds",
    "RI_Year",
    "PreCarrageBy",
    "PalceOfReceipt",
    "PalceOfReceiptCode",
    "PalceOfReceipt_Customized",
    "PortOfLoading",
    "PortOfLoadingCode",
    "PortOfLoading_Customized",
    "PortofTransshipment",
    "PortofTransshipment_LOCode",
    "PortofTransshipment_Customized",
    "TranshipmentVessel",
    "TranshipmentVoyage",
    "PortOfDischarge",
    "PortOfDischargeCode",
    "PortOfDischarge_Customized",
    "LoadingPierTerminal",
    "ClearancePort",
    "ClearancePortCode",
    "CarrierPlaceOfDelivery",
    "CarrierPlaceOfDeliveryCode",
    "CarrierPlaceOfDelivery_Customized",
    "ShipezPlaceOfDelivery",
    "ShipezPlaceOfDeliveryCode",
    "ShipezPlaceOfDeliveryCustomized",
    "FreightLocationName",
    "FreightLocationID",
    "FreightLocationAddress",
    "FirmsCode",
    "EntryNo",
    "CountryOfOrigin",
    "MoveType",
    "MoveTypeHideOnHBL",
    "IsForAMS",
    "CommercialDocumentsReceivedDate",
    "ContainersAvailableDate",
    "DeliveryStatus",
    "AMS_CODate",
    "AMSFilingDate",
    "ISFDetailsReceivedDate",
    "ISF_CODate",
    "ISFFilingDate",
    "Cargo_CODate",
    "EtdAtPol",
    "ContainerOnboardDate",
    "ETDAtTransshipment",
    "ETAPOD",
    "ArrivalNoticeETA",
    "PlaceofDeliveryETA",
    "ETADestination",
    "CarrierMBLReceivedDate",
    "LiveUnloadDate",
    "DropDate",
    "ContnrPickupDate",
    "ITNumber",
    "ITPlace",
    "ITDate",
    "LastFreeDate",
    "CarrierReleaseDate",
    "CustomsBrokerageRequiredDate",
    "CustomsReleaseDate",
    "CustomsholdExam",
    "DeliveryOrderSentDate",
    "CarrierArrivalNoticeReceivedDate",
    "ArrivalNoticeSenttoBrokerDate",
    "FreightChargesPaidDate",
    "InvoiceDate",
    "InvoiceNumber",
];

export const PARTIES_FORM_FIELD_KEYS = [
    "supplierName",
    "supplierID",
    "supplierAddress",
    "sameAsShipperSupplier",
    "SellerName",
    "SellerID",
    "SellerAddress",
    "IsSeller_SameShip",
    "ConsolidatorName",
    "ConsolidatorID",
    "ConsolidatorAddress",
    "IsConsolidator_SameShip",
    "StufferName",
    "StufferID",
    "StufferAddress",
    "IsStuffer_SameShip",
    "ImporterName",
    "ImporterID",
    "ImporterAddress",
    "IsImporter_SameConsign",
    "BuyerName",
    "BuyerID",
    "BuyerAddress",
    "IsBuyer_SameConsign",
    "ShipToName",
    "ShipToID",
    "ShipToAddress",
    "IsShipTo_SameConsign",
    "Shipper",
    "ShipperID",
    "ShipperAddress",
    "Consignee",
    "ConsigneeID",
    "ConsigneeAddress",
];

export function buildSliceSignature(formData, keys) {
    if (!formData) return "";
    const parts = new Array(keys.length);
    for (let i = 0; i < keys.length; i++) {
        const v = formData[keys[i]];
        parts[i] = v === undefined || v === null ? "" : String(v);
    }
    return parts.join("\u0001");
}

export function pickFormFields(formData, keys) {
    if (!formData) return {};
    const o = {};
    for (let i = 0; i < keys.length; i++) {
        const k = keys[i];
        o[k] = formData[k];
    }
    return o;
}
